<template>
  <span class="add-horse-container">
    <!-- <div class="backdrop" @click.self="closeModal"> -->
    <div class="backdrop">
      <div class="add-horse-modal">
        <div class="close-btn">
          <button @click.self="closeModal">x</button>
        </div>
        <slot></slot>
        <div class="actions">
          <slot name="links"></slot>
        </div>
      </div>
    </div>
  </span>
</template>
<script>
export default {
  emits: ["modalKey"],
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans");

.add-horse-modal {
  width: 500px;
  padding: 20px;
  margin: 100px auto;
  background: #fff;
  border-radius: 10px;
  font-family: "Open Sans", sans-serif;
  z-index: 10001;
}

.backdrop {
  top: 0;
  left: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 10000;
}

.close-btn {
  text-align: right;
  width: 50px;
  float: right;
}
.close-btn button {
  font-weight: 300;
  background-color: #1a7c9c;
  border: none;
  color: #fff;
  padding: 0.5em 0.75em;
  font-size: 1em;
}

.add-horse-container .add-bb-heading {
  color: #1a7c9c;
  border: none;
  padding: 0;
  text-transform: uppercase;
  font-size: 1.5em;
  margin-block-start: 0.67em;
  margin-block-end: 0.67em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}

.add-horse-modal .actions {
  text-align: right;
  margin: 30px 0 10px 0;
}

.add-horse-modal .actions a {
  color: #fff;
  padding: 8px;
  border: 1px solid #265cff;
  border-radius: 4px;
  text-decoration: none;
  margin: 10px;
  background: #265cff;
}

.add-horse-container input {
  border: none;
}
::-webkit-input-placeholder {
  color: rgba(34, 32, 32, 0.65);
}

::-webkit-input-placeholder .input-line:focus + ::input-placeholder {
  color: #fff;
}

.input-line {
  background: none;
  margin-bottom: 10px;
  line-height: 2.4em;
  color: #000;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  letter-spacing: 0px;
  letter-spacing: 0.02rem;
  font-size: 19px;
  font-size: 1.2rem;
  border-bottom: 1px solid #1a7c9c !important;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.full-width {
  width: 100%;
}

.input-fields {
  margin-top: 25px;
}

.add-horse-container a {
  color: #1a7c9c;
  text-decoration: none;
}

.add-horse-container a:hover {
  text-decoration: underline;
}

.add-horse-btn-primary {
  color: #fff;
  background-color: #1a7c9c;
  border-color: #184352;
}

.add-horse-btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  margin: 0.3em 0.5em;
}

.add-horse-btn-primary:hover {
  color: #fff;
  background-color: #61b0cc;
  border-color: #5eb6d3;
}
.add-horse-btn-block {
  width: 50%;
}

.add-horse-message {
  border: rgb(197, 49, 49) solid 1px;
  padding: 1em;
  border-radius: 10px;
  font-size: 0.8em;
  background-color: rgb(245, 217, 217);
}

.add-horse {
  border: solid #61b0cc 1px;
  border-radius: 3px;
}

.add-horse-header {
  padding: 1em;
  background-color: #f1f1f1;
  border-radius: 3px;
}
.add-horse-body {
  padding: 1em;
}

.add-horse-comment-text {
  display: block;
  width: 95%;
  padding: 0.75em;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.add-horse-footer {
  text-align: right;
}

@media only screen and (max-width: 768px) {
  .add-horse-modal {
    width: 95%;
  }
}
</style>
